export const sideNavWidth = 195;
export const sideNavCollapsedWidth = 60;
export const sideNavHoverOffset = 14;
export const sideNavCollapsedHoverOffset = 5;
export const sideNavTransitionDuration = 300;
export const sideNavTransitionEasing = "cubic-bezier(0.22, 1, 0.36, 1)";
export const sideNavTransition = `${sideNavTransitionDuration}ms ${sideNavTransitionEasing}`;
export const sideNavContentId = "primary-side-navigation-content";
export const desktopTopNavZIndex = 1200;
export const mobileTopNavZIndex = 1400;
export const desktopTopNavHorizontalPadding = 50;
export const desktopTopNavActionsGap = 20;
export const desktopTopNavActionsFallbackWidth = 206;
export const supportCollapseDuration = 180;
export const collapsedNavItemWidth = 32;
export const navIconSize = 13;
export const collapsedIconGap = 13;
export const collapsedIconLeft = (collapsedNavItemWidth - navIconSize) / 2;

export const mobileNavBreakpointPx = 900;
export const mobileNavDrawerId = "mobile-navigation-drawer";
export const mobileNavHeaderHeight = 55;
export const mobileNavTransitionDuration = 300;
